<template>
  <div>
    <div>
      <v-card-subtitle>
        <h3>Заголовок для панели переключения полей</h3>
      </v-card-subtitle>
      <v-card-text>
        <v-text-field
          v-model="settings.referencePanelTitle"
          class="pt-0"
          label="Заголовок панели переключения полей"
          hide-details
        />
      </v-card-text>
    </div>
    <div>
      <v-card-subtitle>
        <h3>
          Список полей переключения
          <v-btn class="ml-1" x-small icon @click="addReference">
            <v-icon>add</v-icon>
          </v-btn>
        </h3>
        <small>
          Данная функция предназначена для переключения полей,
          на основе которых проводится интерполяция цвета, или определяется цвет по значению
        </small>
      </v-card-subtitle>
    </div>
    <v-card-text class="pt-0">
      <div
        v-for="(field, idx) in settings.referenceProperties"
        :key="idx"
        class="d-flex align-center"
      >
        <v-col md="3">
          <custom-select
            v-if="mappings.length"
            :list="mappings"
            :data="settings.referenceProperties[idx].key"
            item-value="key"
            item-text="value"
            class="mr-2 flex-grow-1 flex-shrink-1"
            label="Исходное название поля"
            hide-details
            @change="(id) => settings.referenceProperties[idx].key = id"
          />
        </v-col>

        <v-btn class="ml-2 mt-4" icon color="red" @click="removeReference">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
      <div v-if="settings.referenceProperties.length === 0">
        Поля не добавлены.
        <span v-if="!settings.mappings.length">
          Необходимо выбрать поля панели аттрибутов.
        </span>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select';

const createDefaultMapping = () => ({
  key: '',
});

export default {
  name: 'reference-properties',

  components: {
    CustomSelect,
  },

  props: {
    settings: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mappings() {
      return this.settings.mappings;
    },
  },

  watch: {
    mappings(value) {
      const mappingKeys = value.map((v) => v.key);
      this.settings.referenceProperties = this.settings.referenceProperties.filter(
        (property) => mappingKeys.includes(property.key),
      );
    },
  },

  methods: {
    addReference() {
      if (!this.mappings.length) {
        return;
      }
      this.settings.referenceProperties.push(createDefaultMapping());
    },

    removeReference(key) {
      this.settings.referenceProperties.splice(key, 1);
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
